import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 700px;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary.vividCerulean};
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  width: 100%;
`;
